export default "__VITE_ASSET___u5vqpAU__"